import { render, staticRenderFns } from "./fillter.vue?vue&type=template&id=55154812"
import script from "./fillter.vue?vue&type=script&lang=js"
export * from "./fillter.vue?vue&type=script&lang=js"
import style0 from "./fillter.vue?vue&type=style&index=0&id=55154812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports